import styled from "styled-components";
import mixins, { media } from "../../styles/mixins";
import { getCookie } from "../../utils/utils";
import { useNavigate } from "react-router-dom";

const Wrap = styled.div`
	float: right;
	display: flex;
	align-items: center;
	font-size: 18px;
	font-weight: 400;
	color: #000;
	margin-bottom: 17px;
	gap: 4px;
	cursor: pointer;

	.back-icon {
		width: 24px;
		height: 24px;
		padding: 2.5px 0 2.5px 4.5px;

		> svg {
			display: block;
			width: 100%;
			height: 100%;
		}
	}

	& + * {
		clear: both;
	}

	${media.mobile`
		position: absolute;
		top: -56px;
		right: 20px;
		width: auto;
		margin: 0;
		z-index: 1;
		font-size: 14px;
	`}
`;

/**
 * 대시보드로 돌아가는 뒤로가기 버튼
 * eventPath 쿠키 기반으로 대시보드 경로를 복원하므로 새로고침해도 유지됨
 */
const BtnBack = () => {
	const navigate = useNavigate();
	const eventPath = getCookie("eventPath");

	// 대시보드 경로를 알 수 없으면 미노출
	if (!eventPath) return null;

	const handleClick = () => {
		navigate(`/dashboard/${eventPath}`);
	};

	return (
		<Wrap onClick={handleClick}>
			<div className="back-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
					<rect x="0.707031" y="9.19249" width="1" height="12" transform="rotate(-135 0.707031 9.19249)" fill="#06315B" />
					<rect y="8.48521" width="1" height="12" transform="rotate(-45 0 8.48521)" fill="#06315B" />
				</svg>
			</div>
			뒤로가기
		</Wrap>
	);
};

export default BtnBack;
